import React from 'react';
import { Navbar } from './marketing/Navbar';
import { Hero } from './marketing/Hero';
import { HowItWorks } from './marketing/HowItWorks';
import { Features } from './marketing/Features';
import { UseCases } from './marketing/UseCases';
import { SocialProof } from './marketing/SocialProof';
import { Pricing } from './marketing/Pricing';
import { FAQ } from './marketing/FAQ';
import { CTA } from './marketing/CTA';
import { Footer } from './marketing/Footer';

export function LandingPage() {
  return (
    <div className="landing" style={{ background: '#080810' }}>
      <div className="flex min-h-screen flex-col">
        <Navbar />
        <main className="flex-1">
          <Hero />
          <HowItWorks />
          <Features />
          <UseCases />
          <SocialProof />
          <Pricing />
          <FAQ />
          <CTA />
        </main>
        <Footer />
      </div>
    </div>
  );
}
